import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

type CreateGroupModalProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: (name: string) => void | Promise<void>;
	isSubmitting?: boolean;
};

/**
 * Modal to create a new group
 * @param open - Whether the modal is open
 * @param onOpenChange - Function to call when the modal is opened or closed
 * @param onConfirm - Function to call when the form is submitted
 * @param isSubmitting - Whether the form is submitting
 */
export function CreateGroupModal({
	open,
	onOpenChange,
	onConfirm,
	isSubmitting = false,
}: CreateGroupModalProps) {
	const [name, setName] = useState("");

	useEffect(() => {
		if (!open) {
			setName("");
		}
	}, [open]);

	const handleSubmit = async () => {
		const trimmed = name.trim();
		if (!trimmed || isSubmitting) return;
		await onConfirm(trimmed);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Neue Gruppe erstellen</DialogTitle>
					<DialogDescription>
						Bitte geben Sie den Namen der neuen Gruppe ein. Sie können auf dem
						Tab "Personen verwalten" Personen zu einer Gruppe hinzufügen.
					</DialogDescription>
				</DialogHeader>
				<div className="py-2">
					<Input
						value={name}
						onChange={(e) => setName(e.target.value)}
						placeholder="Gruppenname"
						autoFocus
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault();
								handleSubmit();
							}
						}}
					/>
				</div>
				<DialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						Abbrechen
					</Button>
					<Button
						onClick={handleSubmit}
						disabled={isSubmitting || name.trim().length === 0}
					>
						Erstellen
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default CreateGroupModal;
